class ProductSiblings extends HTMLElement {
  static observedAttributes = ["title", "product-id", "hide-current"];

  constructor() {
    super();

    this.colorUrl = this.dataset.colorUrl;
    console.log('Product Siblings: Started', this.colorUrl);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(
      `Attribute ${name} has changed from ${oldValue} to ${newValue}.`,
    );
    switch (name) {
      case "title" || "hide-current":
        if (newValue) {
          this.init(newValue);
        }
        break;

      case "product-id":
        if (/^\d+$/.test(newValue)) {
          this.currentId = +newValue
        }
        break;
    }
  }

  handleize(name) {
    return name
      .toString()
      // Normalize accented characters to their base form
      .normalize('NFKD')
      // Remove all non-word characters except spaces and hyphens
      .replace(/[^\w\s-]/g, '')
      // Trim leading/trailing whitespace
      .trim()
      // Lowercase the string
      .toLowerCase()
      // Replace spaces and underscores with hyphens
      .replace(/[\s_]+/g, '-')
      // Collapse multiple hyphens into one
      .replace(/-+/g, '-');
  }

  sorted(arr = []) {
    if (!Array.isArray(arr)) return arr;
    return arr.sort((a, b) => {
      const nameA = a.swatch.name.toLowerCase();
      const nameB = b.swatch.name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
  }

  dataTransform(arr = []) {
    if (!Array.isArray(arr)) return arr;
    let data = [];

    for (const { node } of arr) {
      const { id, options, handle, title } = node;
      const colorOpt = options?.find(({name: n}) => n.toLowerCase() === 'color' || n.toLowerCase() === 'colour');
      if (!colorOpt) continue;

      const { optionValues } = colorOpt;
      for (const value of optionValues) {
        const colorHandle = this.handleize(value.name)
        data.push({
          id,
          handle,
          title,
          swatch: {
            name: value.name,
            color: value?.swatch?.color,
            image: {
              url: value?.swatch?.image?.previewImage?.url || `https:${this.colorUrl.replace('xxxx', colorHandle)}`,
              altText: value?.swatch?.image?.previewImage?.altText
            }
          }
        })
      }
    }

    return this.sorted(data);
  }

  async init(newValue) {
    this.settings = {
      hideCurrent: this.getAttribute('hide-current') === "true" ? true : false
    }

    const query = `{
      products(first: 25, query:"title:${newValue}*") {
        edges {
          node {
            id
            title
            handle
            options(first: 25) {
              name
              optionValues {
                name
                swatch {
                  color
                  image {
                    previewImage {
                      url
                      altText
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`;

    try {
      const req = await fetch(`https://ganactive-com.myshopify.com/api/2025-04/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": "34744926c84ed526ad80a9b52af4efc5"
        },
        body: query
      });
      const res = await req.json();

      // console.log({ res, req })
      if (req.ok) {
        if (!res.data) {
          console.log('Product Siblings: Missing data. Please try again');
          return;
        }
        const { products: { edges: products } } = res.data;
        const filtered = products.filter(p => p.node.title.startsWith(newValue));
        this.renderProducts(filtered);
      }
    } catch (error) {
      console.log('Error in processing product siblings. Please try again', { error });
    }
  }

  renderProducts(data = null) {
    if (!data) {
      this.handleError(res);
      return;
    }
    console.log({ data });

    const products = this.dataTransform([...data]);
    console.log({ products });

    const content = document.createElement('div');
    content.classList.add('siblings', 'flex', 'flex-wrap');
    content.innerHTML = products.map(({ id, title, handle, swatch }) => {
      const pid = id.split('/').at(-1);
      const isCurrentProduct = +pid === this.currentId;
      const swatchName = swatch.name || title;
      const renderSwatch = (swatch, name) => {
        const {color, image} = swatch;
        return `
          <span class="swatch-item${color ? ' has-color' : ''}" style="--aspect-ratio: 1; --bg-color: ${color || ''}">${image && image.url ?
            `<img src="${image.url}" class="theme-img" alt="${image && image.altText ? altText : name}" loading="lazy" width="24" height="24" onerror="this.remove()">`
            : ''
          }</span>
        `
      };

      return `
        <a href="/products/${handle}" class="opt-label opt-label--btn btn relative text-center align-center${isCurrentProduct ? ' active' : ''}${this.settings.hideCurrent && isCurrentProduct ? ' hidden' : ''}">
          ${swatch ? renderSwatch(swatch, swatchName) : ''}${swatchName}
        </a>
      `
    }).join('');

    const existingSiblingEl = this.querySelector('.siblings');
    if (existingSiblingEl) existingSiblingEl.remove();

    this.appendChild(content);
    this.classList.remove('hidden');
  }
}
if (!customElements.get('product-siblings')){
  customElements.define('product-siblings', ProductSiblings);
}